let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3IA7L")).then(() => parcelRequire('3vd6f'));